<script lang="ts" setup>
import {onMounted} from "vue";
import {useQuizStore} from '@/stores/quizStore';
import ClaimsUnlocked from "@/components/Quiz/ClaimsUnlocked.vue";
import StillSearching from "@/components/Quiz/StillSearching.vue";
import { gtmCreditCheck, mktCreditCheck } from '@/helpers/marketingEvents.ts'
import { useRouter } from 'vue-router'

export type THandler = 'clientPortalUrl' | 'home'

const router = useRouter()
const trustpilotUrl = 'https://www.trustpilot.com/evaluate/my.claimsforcars.com'
const {
  agreementsCount,
  clearStore,
  getStoredData,
  clientPortalUrl,
  vehicles,
  consentMarketing,
  leadSource,
  aagLeadToken,
} = useQuizStore()

const storedData = getStoredData()

function delayAction(callback: () => void, wait: number = 100) {
  setTimeout(() => {
    callback()
  }, wait)
}

function goToHome() {
  router.push({name: 'home'})
}

function goToClientPortalUrl() {
  window.location.href = clientPortalUrl.value
}

onMounted(() => {
  gtmCreditCheck(storedData.email, storedData.contact.phone)
  aagLeadToken.value.pcp.forEach((token: string) => {
    mktCreditCheck(token, agreementsCount.value, leadSource.value, consentMarketing.value)
  })
  aagLeadToken.value.dpf.forEach((token: string) => {
    mktCreditCheck(token, agreementsCount.value, leadSource.value, consentMarketing.value)
  })
  clearStore()
})
</script>

<template>
  <ClaimsUnlocked v-if="agreementsCount" :email="storedData.email" :hasPcp="!!vehicles.length"/>

  <StillSearching v-if="!agreementsCount" :email="storedData.email"/>

  <div class="flex justify-between gap-4 mt-6">
    <a
      :href="trustpilotUrl"
      target="_blank"
      class="w-full py-2 rounded-md transition cursor-pointer disabled:cursor-not-allowed flex items-center gap-2 justify-center px-4 bg-[#FFDE02] disabled:bg-[#FFDE02]/60 disabled:text-gray-900"
      :class="{ '!w-1/2': clientPortalUrl }"
      @click="() => delayAction(goToHome)"
    >Submit another claim</a>
    <a
      v-if="clientPortalUrl"
      :href="trustpilotUrl"
      target="_blank"
      class="w-1/2 py-2 px-4 bg-green-500 text-center text-white rounded-md font-medium cursor-pointer disabled:cursor-not-allowed disabled:text-gray-100 disabled:bg-(--brand-primary)/90 transition flex items-center justify-center"
      @click="() => delayAction(goToClientPortalUrl)"
    ><span>View your claims</span></a>
  </div>
</template>
